export const URL_SERVICIOS = 'https://fv4.jlsvve.org.mx/api/';